import Context from "../../../context/Context";

export function generateRandomId() {
  const t = Date.now();
  const r = (""+Math.random()).replace("0.","r");
  return (t+""+r).replace(/-/g,"");
}

export function makeIcsInfo(eventInfo, filename) {
  const promise = new Promise((resolve,reject) => {
    try {
      const icsInfo = {
        blob: null,
        data: null,
        href: null,
        filename: filename || "event.ics"
      }
      const data = icsInfo.data = makeIcsString(eventInfo);
      if (data && FileReader && Blob) {
        const blob = icsInfo.blob = new Blob([data], {type:"text/calendar"});
        const reader = new FileReader();
        reader.onload = function(event) {
          icsInfo.href = event.target.result;
          resolve(icsInfo);
        };
        reader.onerror = function(err) {
          reject(err);
        }
        reader.readAsDataURL(blob);
      } else {
        resolve(icsInfo);
      }
    } catch(ex) {
      reject(ex);
    }
  });
  return promise;
}

function makeIcsString(eventInfo) {

  const chkStr = (v) => {
    if (typeof v !== "string") return "";
    return v;
  }

  const formatDate = (date) => {
    if (date === undefined || date === null) return null;
    if (typeof date === "number") {
      date = new Date(date);
    }
    const opts = {zulu: true};
    const lib = Context.getInstance().lib;
    let v = lib.dojo.stamp.toISOString(date,opts);
    //console.log("formatDate",v,date);
    v = v.replace(/-/g,"").replace(/:/g,"");
    return v;
  };

  const prodid = "ArcGIS Indoors"; // TODO?
  const uid = ""+generateRandomId();
  const summary = chkStr(eventInfo.name);
  const description = chkStr(eventInfo.description);
  const hyperlink = chkStr(eventInfo.hyperlink);
  const location = chkStr(eventInfo.location);
  const dateNow = formatDate(new Date());
  const dateStart = formatDate(eventInfo.date_start);
  const dateEnd = formatDate(eventInfo.date_end);

  let geo = eventInfo.geo;
  if (!geo) {
    let geometry = eventInfo.geometry;
    if (geometry && geometry.type === "polygon") {
      geometry = geometry.centroid;
    }
    if (geometry && geometry.type === "point") {
      if (typeof geometry.latitude === "number" &&
          typeof geometry.longitude === "number") {
        geo = geometry.latitude + ";" + geometry.longitude;
      }
    }
  }
  geo = chkStr(geo);

  if (summary.length === 0 || !dateStart) {
    return null; // not enough info
  }

  let ics = [
    "BEGIN:VCALENDAR",
    "PRODID:" + prodid,
    "VERSION:2.0",
    "BEGIN:VEVENT",
    "UID:" + uid,
    "DTSTAMP:" + dateNow
  ];
  if (dateStart) ics.push("DTSTART:" + dateStart);
  if (dateEnd) ics.push("DTEND:" + dateEnd);
  if (summary.length > 0) ics.push("SUMMARY:" + summary);
  if (location.length > 0) ics.push("LOCATION:" + location);
  if (geo.length > 0) ics.push("GEO:" + geo);
  if (description.length > 0) ics.push("DESCRIPTION:" + description);
  if (hyperlink.length > 0) ics.push(hyperlink);
  ics = ics.concat([
    "END:VEVENT",
    "END:VCALENDAR"
  ]);

  // "CLASS:PUBLIC", // TODO?
  // "TRANSP:TRANSPARENT",   // TODO?

  const delimeter = "\n";
  const data = ics.join(delimeter);
  //console.log(data);
  return data;
}
